import React from 'react';
import { AdPlaceholder } from '../shared/AdPlaceholder';

interface GameOverScreenProps {
    onRestart: () => void;
}

export const GameOverScreen = ({ onRestart }: GameOverScreenProps) => (
    <>
        <AdPlaceholder />
        <div className="game-over-screen">
            <h1>Game Over 😵</h1>
            <p>Your club has gone into administration due to overwhelming debt.</p>
            <button className="button primary" onClick={onRestart}>Start New Game</button>
        </div>
    </>
);